import { useState } from "react";
import { navLinks } from "@/mocks/guaData";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const go = (id: string) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/90 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-2.5"
          aria-label="每日有瓜首页"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50">
            <i className="ri-chat-smile-3-line" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
            每日有瓜
          </span>
          <span className="hidden rounded-full bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-700 sm:inline">
            实时围观
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navLinks.map((l) => (
            <button
              key={l.key}
              onClick={() => go(l.key)}
              className="whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-medium text-foreground-700 transition hover:bg-primary-50 hover:text-primary-700"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#subscribe"
            onClick={(e) => {
              e.preventDefault();
              go("subscribe");
            }}
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition hover:bg-primary-600 sm:inline-flex"
          >
            订阅瓜报
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
            aria-label={open ? "关闭菜单" : "打开菜单"}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200/80 bg-background-50 lg:hidden">
          <nav className="mx-auto grid max-w-7xl grid-cols-2 gap-1 px-4 py-4 md:px-6">
            {navLinks.map((l) => (
              <button
                key={l.key}
                onClick={() => go(l.key)}
                className="whitespace-nowrap rounded-md px-3 py-2.5 text-left text-sm font-medium text-foreground-700 transition hover:bg-primary-50 hover:text-primary-700"
              >
                {l.label}
              </button>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}